// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 22:10:14

export default {
  "id": "stack-n-sort",
  "slug": "stack-n-sort",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/3d150c1161674a72a4f1fdab9914b13b-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/3d150c1161674a72a4f1fdab9914b13b/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Stack n Sort",
      "description": "Welcome to Stack n Sort, the ultimate color stack game that combines precision, hoop sort strategy, and excitement in one addictive experience.\n\nImmerse yourself in a world of vibrant stack color and dynamic hoop sort challenges as you test your skills and aim for high scores. Whether you’re a casual gamer or a competitive enthusiast, hoop stack offers endless fun and engagement.",
      "instructions": "Using mouse to move the ropes",
      "genres": [
        "Casual",
        "Puzzle"
      ],
      "tags": [
        "1player"
      ]
    },
    "zh-CN": {
      "title": "堆叠排序",
      "description": "欢迎来到Stack n Sort，这款终极色彩堆叠游戏，将精准度、篮筐排序策略和激动人心的体验完美结合。\n\n沉浸在充满活力的色彩堆叠和动态篮筐排序挑战的世界中，测试你的技巧，争取高分。无论你是休闲玩家还是竞技爱好者，篮筐堆叠都提供无尽的乐趣和参与感。",
      "instructions": "使用鼠标移动绳索",
      "genres": [
        "休闲",
        "解谜"
      ],
      "tags": [
        "1人玩家"
      ]
    },
    "zh-TW": {
      "title": "堆疊排序",
      "description": "歡迎來到 Stack n Sort，這是一款結合精準、籃圈分類策略及興奮感的終極顏色堆疊遊戲，帶給你一個上癮的體驗。\n\n沉浸於充滿生機的顏色堆疊世界中，挑戰動態的籃圈分類挑戰，測試你的技巧並追求高分。無論你是休闲玩家還是競技熱情者，籃圈堆疊都帶來無盡的樂趣和參與感。",
      "instructions": "使用滑鼠移動繩索",
      "genres": [
        "隨意",
        "謎題"
      ],
      "tags": [
        "1人玩家"
      ]
    },
    "zh-HK": {
      "title": "堆疊排序",
      "description": "歡迎來到 Stack n Sort，最終極的色彩堆疊遊戲，將準確度、環形分類策略及興奮感融入一個令人上癮的體驗中。\n\n沉浸在生動多彩的堆疊色彩和動態環形分類挑戰的世界中，你將測試你的技巧，追求高分。無論你是休閒玩家還是競賽狂熱者，環形堆疊都提供無窮的樂趣和參與感。",
      "instructions": "使用滑鼠移動繩索",
      "genres": [
        "隨意遊戲",
        "謎題遊戲"
      ],
      "tags": [
        "1人玩"
      ]
    },
    "ja": {
      "title": "スタックンソート",
      "description": "スタックンソートへようこそ、ピッタリの色を積み重ねる究極の色 stack ゲームです。この一つの魅力的な体験で、正確さ、バスケットソート戦略、興奮を融合させました。\n\n鮮やかな色のスタックとダイナミックなバスケットソートの挑戦に没頭し、スキルを試しながら高得点を目指してください。カジュアルなゲーマーでも競争的なエキスパートでも、バスケットスタックは無限の楽しみとエンゲージメントを提供します。",
      "instructions": "マウスを使用してロープを移動",
      "genres": [
        "カジュアル",
        "パズル"
      ],
      "tags": [
        "1プレイヤー"
      ]
    },
    "ko": {
      "title": "스택 나 스타일",
      "description": "스택 'n' 스팟에 오신 것을 환영합니다. 정확성, 휠 정렬 전략, 그리고 흥분을 한가지 매력적인 경험으로 결합한 최종적인 컬러 스택 게임입니다.\n\n대담한 스택 컬러와 동적 휠 정렬 도전 과제 속으로 빨리 들어가세요. 자신의 기술을 테스트하고 높은 점수를 노리세요. 캐주얼 게이머이든 경쟁 열렬한 팬이든, 휠 스택은 끝없는 재미와 참여를 제공합니다.",
      "instructions": "마우스로 나무줄 이동",
      "genres": [
        "캐주얼",
        "پازل"
      ],
      "tags": [
        "1플레이어"
      ]
    },
    "fr": {
      "title": "Empiler et Trier",
      "description": "Bienvenue dans Stack n Sort, le jeu de stackage de couleurs ultime qui combine précision, stratégie de tri des cercles et excitation dans une expérience accrocheuse.\n\nImmergez-vous dans un monde de stacks de couleurs vibrantes et de défis dynamiques de tri des cercles, tout en testant vos compétences et en visant des scores élevés. Que vous soyez un joueur occasionnel ou un passionné de compétition, le tri des cercles offre un plaisir infini et une engagement constant.",
      "instructions": "Utiliser la souris pour déplacer les cordes",
      "genres": [
        "Facile",
        "Puzzle"
      ],
      "tags": [
        "1 joueur"
      ]
    }
  }
};
